const initData = {
  row:{
    student_name:'',
    student_namej:'',
    sex:3,
    updated_at:'',
    enrollment_status: 0,
  },
  studentInfo: {
    // 生徒情報
    guardianName: '',
    guardianRelationship: '',
    academicType: '',
    academicYear: '',
    schoolName: '',
    schoolCategory: '',
    schoolDeviation: '',
    course: '',
    semester: '',
    address1: '',
    address2: '',
    postalCode: '',
    emergencyContact1Relationship: '',
    emergencyContact1: '',
    emergencyContact2Relationship: '',
    emergencyContact2: '',
    studentRemark: '',
    email: '',
    salesRepresentativeName: '',
    instructorName: '',
    interviewDate: '',
    interviewStartTime: '',
    interviewEndTime: '',
    procedureDate: '',
    procedureStartTime: '',
    procedureEndTime: '',
    adaptiveCampaigns: '',
  },
  // 入会までの経緯
  background: {
    inquiryMedia: '',
    preparationBeforeJoining: '',
    countermeasures: '',
    inquiryReason: '',
    compareWithOther: '',
    salesExperience: '',
    reactionToCosts: '',
    whoDecideToJoin: '',
    reasonForRejectOther: '',
  },
  // 状況調査
  survey: {
    lesson1: '',
    lesson2: '',
    lesson3: '',
    lesson4: '',
    lesson5: '',
    lesson6: '',
    lesson7: '',
    learningAbout: '',
    clubHobbyDream: '',
    siblingInfo: '',
    surveyRemark: '',
  },
  // 体験時の参加者について
  experienceParticipants: [
    {
      participant: '',
      personality: '',
    },
    {
      participant: '',
      personality: '',
    },
    {
      participant: '',
      personality: '',
    },
    {
      participant: '',
      personality: '',
    },
  ],
  // 登録情報
  registrationInfo: {
    center_name: '',
    courseInfo1: '',
    courseInfo2: '',
    courseInfo3: '',
    courseInfo4: '',
    courseList: Array(7).fill().map(() => ({
      subject: '',
      dayOfWeek: '',
      startTime: '',
      firstScheduleDate: '',
      registrationType: '',
      changedDayOfWeek: '',
      changedTime: '',
      changedStartDate: '',
    }))
  },
  // ご要望
  requirement: {
    mainTask1: '',
    mainTask2: '',
    expectationRemarks: '',
    aboutParent: ''
  },
  // （志望校情報）
  interestSchoolInfo: {
    schoolList: [
      {
        order: '1',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
      {
        order: '2',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
      {
        order: '3',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
      {
        order: '4',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
      {
        order: '5',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
    ],
    understandingOfExamInfo: ''
  },
  // 授業環境
  lessonEnvironment: {
    equipment: '',
    remarks: ''
  },
  // カリキュラム
  subject: [
    {
      lesson1: '',
      lesson1Info: '',
      lesson2: '',
      lesson2Info: '',
      textbooks: [
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        }
      ],
      startPosition: '',
      specialNote: '',
      lessonProgress: '',
      homework: '',
      averageTimeforHomework: '',
    }
  ]
};
const sampleData =  {
  finalUpdateDate: '2020/01/01',
  studentInfo: {
    studentHiraganaName: 'むらおか いと',
    studentName: '村岡 綸',
    studentGender: '女',
    guardianName: '村岡 弘輝',
    guardianRelationship: '父',
    academicType: '小学',
    academicYear: '2',
    schoolName: '五十嵐小学校',
    schoolCategory: '市立',
    schoolDeviation: '-',
    course: '-',
    semester: '２学期',
    address1: '新潟県',
    address2: '新潟市西区上新栄町0-0-0',
    postalCode: '950-0000',
    emergencyContact1Relationship: '母',
    emergencyContact1: '080-0000-xxxx',
    emergencyContact2Relationship: '父',
    emergencyContact2: '080-4815-7463',
    studentRemark: 'メールアドレスは父親の会社アドレス',
    email: 'muraoka@hmgroup.co.jp',
    salesRepresentativeName: '岡田',
    instructorName: '湊',
    interviewDate: '2025/2/11(火)',
    interviewStartTime: '14:00',
    interviewEndTime: '',
    procedureDate: '2025/2/21(金)',
    procedureStartTime: '16:00',
    procedureEndTime: '17:00',
    adaptiveCampaigns: '入会金16,500円 OFF',
  },
  background: {
    inquiryMedia: '公式ホームページ',
    preparationBeforeJoining: 'パロンテアンファン(早期教育系らしい)・チャレンジタッチ・近所の個人塾(名称話していたが聞き取れず)',
    countermeasures: 'パロンテアンファンは継続併用する予定、他は考え中',
    inquiryReason: '中学受験の予定はないが、中学の学習に向けて早めに対策をしたい',
    compareWithOther: '公文',
    salesExperience: '算数 単位の変換（予習）',
    reactionToCosts: 'とんとん拍子だが、サイトと違う理由は父から質問あり',
    whoDecideToJoin: '母親',
    reasonForRejectOther: '不明、料金質問はあったものの体験後から両親前向きに。公文は距離問題の懸念はあった様子',
  },
  survey: {
    lesson1: 'ピアノ個人',
    lesson2: '個人塾',
    lesson3: 'パロンテアンファン',
    lesson4: '',
    lesson5: '個人塾',
    lesson6: 'ピアノ集団',
    lesson7: 'エレクトーン',
    learningAbout: '算数は得意だが極めたいとのこと、国語は苦手意識あり',
    clubHobbyDream: 'ピアノが得意、コンクールなどで振替可能性あり',
    siblingInfo: '一人っ子',
    surveyRemark: '父親がかなり細かいので、質問が多いかもしれません、\n主体は母親です。',
  },
  experienceParticipants: [
    {
      participant: '本人',
      personality: 'よく話す、積極的、自信がある',
    },
    {
      participant: '母親',
      personality: '穏やかだが、実質的な主権者',
    },
    {
      participant: '父親',
      personality: '同業者のためか指導にこだわりが強い',
    },
    {
      participant: '',
      personality: '',
    },
  ],
  registrationInfo: {
    courseInfo1: '４０分後半',
    courseInfo2: '１対１',
    courseInfo3: 'アドバンス',
    courseInfo4: 'スタンダード',
    courseList: [
      {
        subject: '算数',
        dayOfWeek: '土',
        startTime: '5m(s) 17:30～',
        firstScheduleDate: '3/A(土)',
        registrationType: '登録',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
      {
        subject: '国語①',
        dayOfWeek: '水',
        startTime: '5m(s) 17:30～',
        firstScheduleDate: '3/B(水)',
        registrationType: '登録',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
      {
        subject: '国語②',
        dayOfWeek: '金',
        startTime: '5m(s) 17:30～',
        firstScheduleDate: '3/B(金)',
        registrationType: '登録',
        changedDayOfWeek: '土',
        changedTime: '4m(s) 15:40～',
        changedStartDate: '5/A(土)',
      },
      {
        subject: '',
        dayOfWeek: '',
        startTime: '',
        firstScheduleDate: '',
        registrationType: '',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
      {
        subject: '',
        dayOfWeek: '',
        startTime: '',
        firstScheduleDate: '',
        registrationType: '',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
      {
        subject: '',
        dayOfWeek: '',
        startTime: '',
        firstScheduleDate: '',
        registrationType: '',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
      {
        subject: '',
        dayOfWeek: '',
        startTime: '',
        firstScheduleDate: '',
        registrationType: '',
        changedDayOfWeek: '',
        changedTime: '',
        changedStartDate: '',
      },
    ]
  },
  requirement: {
    mainTask1: '予習による将来への準備',
    mainTask2: '基礎学力定着',
    expectationRemarks: '基本的に予習型で進めていくが、苦手な部分があれば無理に進めず、繰り返してほしい。\n優しい先生希望、本人が勉強嫌いにならないようたくさん褒めてほしい。',
    aboutParent: '出来る限り横に付き添う'
  },
  interestSchoolInfo: {
    schoolList: [
      {
        order: '1',
        classification: '公立',
        schoolName: '新潟高校',
        desire: '可能であれば',
        remarks: '長期将来的な希望、ここに入るために早くから始めたいとのこと',
        deviationValue: '72'
      },
      {
        order: '2',
        classification: '公立',
        schoolName: '新潟南高校',
        desire: '可能であれば',
        remarks: '長期将来的な希望',
        deviationValue: '69'
      },
      {
        order: '3',
        classification: '市立',
        schoolName: '万代高校',
        desire: '最低ライン',
        remarks: '長期将来的な希望',
        deviationValue: '60'
      },
      {
        order: '4',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
      {
        order: '5',
        classification: '',
        schoolName: '',
        desire: '',
        remarks: '',
        deviationValue: ''
      },
    ],
    understandingOfExamInfo: '親が調べていて、かなり詳しい'
  },
  lessonEnvironment: {
    equipment: 'Windows PC',
    remarks: 'カメラは別接続するとのこと\nタブレットはワコム製を所持\niPadに変更の可能性あり'
  },
  subject: [
    {
      lesson1: '算数',
      lesson1Info: '',
      lesson2: '',
      lesson2Info: '',
      textbooks: [
        {
          name: 'New小学生ワーク２年',
          adoption: '東書',
          status: '後日決定プリント送付済',
          pageStart: '46',
          pageEnd: '62',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        }
      ],
      startPosition: '46ページ（予習）から順に進める',
      specialNote: '得意科目なので予習型。話が学習から逸れた際は、一度聞き入れた後に戻す。',
      lessonProgress: '問題を１問ずつ抜粋し、「解き方を軽く説明」→「サポートしながら一緒に解く」→「解き方を説明させる」という流れで進める。\n一方的な要点説明の場面は集中力の関係で不要。\n解き方の説明で躓いた時は、すぐに声をかけ不安にさせないよう留意。',
      homework: '本日解説済み範囲のうち、飛ばした問題の中から丁寧に番号で伝える。',
      averageTimeforHomework: '10',
    },
    {
      lesson1: '',
      lesson1Info: '',
      lesson2: '',
      lesson2Info: '',
      textbooks: [
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        },
        {
          name: '',
          adoption: '',
          status: '',
          pageStart: '',
          pageEnd: '',
        }
      ],
      startPosition: '',
      specialNote: '',
      lessonProgress: '',
      homework: '',
      averageTimeforHomework: '',
    }
  ],
  testScore: null
};

const initSubject = {
  lesson1: '',
  lesson1Info: '',
  lesson2: '',
  lesson2Info: '',
  textbooks: [
    {
      name: '',
      adoption: '',
      status: '',
      pageStart: '',
      pageEnd: '',
    },
    {
      name: '',
      adoption: '',
      status: '',
      pageStart: '',
      pageEnd: '',
    },
    {
      name: '',
      adoption: '',
      status: '',
      pageStart: '',
      pageEnd: '',
    }
  ],
  startPosition: '',
  specialNote: '',
  lessonProgress: '',
  homework: '',
  averageTimeforHomework: '',
}
export { initData,initSubject,sampleData };
